"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocationPathName = void 0;
var react_1 = require("react");
var useLocationPathName = function (location) {
    return react_1.useMemo(function () { return location.pathname.split('/')[1]; }, [location]);
};
exports.useLocationPathName = useLocationPathName;
